import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { Autocomplete } from '@material-ui/lab';
import { Box } from '@material-ui/core';
import { FiChevronDown } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';

import { FormFolderDoc } from '@vyce/core/src/api/types';
import { AppTextField } from '@vyce/core/src/components/inputs/AppTextField';
import { appAutocompleteUseStyles } from '@vyce/core/src/components/controlled-inputs/ControlledAutocomplete';

interface Props {
  folders: FormFolderDoc[];
  selectedFolderId: string;
  onFolderChange: (folderId: string) => void;
  loading?: boolean;
  label?: string;
}

export const FolderAutocomplete: React.FC<Props> = ({
  folders,
  selectedFolderId,
  onFolderChange,
  loading = false,
  label = 'Folder',
}) => {
  const classes = appAutocompleteUseStyles({});
  const selectedFolder = folders.find(folder => folder.id === selectedFolderId) || null;

  return (
    <Autocomplete
      options={folders}
      classes={classes}
      value={selectedFolder}
      onChange={(_, newValue) => onFolderChange(newValue?.id || '')}
      popupIcon={<FiChevronDown size="25px" color="#A0A3BD" />}
      closeIcon={<IoClose size="25px" color="#A0A3BD" />}
      noOptionsText="Not Found"
      getOptionLabel={option => option?.name ?? ''}
      getOptionSelected={(option, value) => option.id === value.id}
      fullWidth
      renderInput={params => (
        <AppTextField
          {...params}
          fullWidth
          label={label}
          margin="dense"
          autoFocus
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <Box position="absolute" right={80} top={18}>
                    <CircularProgress color="secondary" size={20} />
                  </Box>
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
